import React from "react";
import {Typography, Paper, Breadcrumbs, Link} from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/groupsStyle";
import Category from "./Category";
import GroupDevicesProvider from "./Provider";

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {HomeOutlined} from '@material-ui/icons';

import "../../css/storeManagement.scss"
import { Resizable } from "re-resizable";

import StoreBox from "./StoreBox";

const StoreManagement = () => {
  const { t } = useTranslation("groups");
  const classes = useStyles();
  return (
    <>
        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {t({defaultMessage: "门店管理"})}
          </Typography>
        </Breadcrumbs>
        <div className={classes.titleWithSelect}>
          <Typography variant="h4">{t({defaultMessage: "门店管理"})}</Typography>
        </div>
        <div className={`${classes.groupWrapper} store-management-box`}>
          <GroupDevicesProvider>
            <Resizable
              defaultSize={{
                minWidth: 250,
                width: 300
              }}
              enable={{
                top: false,
                right: true,
                bottom: false,
                left: false,
                topRight: false,
                bottomRight: false,
                bottomLeft: false,
                topLeft: false
              }}
              className={classes.sizableGroupWrapper}
            >
              <Paper elevation={0} className={classes.groupList + "  " + classes.sizableGroupList}>
                <Category/>
                {/*<DeviceTags />*/}
              </Paper>
            </Resizable>
            <StoreBox />
          </GroupDevicesProvider>
        </div>
    </>
  );
};

export default StoreManagement;
